import React, { createContext, useState } from 'react';

import { BASIC_INITIAL_STATE } from '@usas/ui-web/utils/HttpHelper';

export const LaneSheetMeetEventAthletesStateContext = createContext();

const INITIAL_STATE = {
  ...BASIC_INITIAL_STATE,
};

const LaneSheetMeetEventAthletesContextProvider = ({ children }) => {
  const stateHook = useState(INITIAL_STATE);

  return (
    <LaneSheetMeetEventAthletesStateContext.Provider value={stateHook}>
      {children}
    </LaneSheetMeetEventAthletesStateContext.Provider>
  );
};

export default LaneSheetMeetEventAthletesContextProvider;